__turbopack_context__.v({
  "banner": "Banner-module-scss-module___R6Yya__banner",
  "disabled": "Banner-module-scss-module___R6Yya__disabled",
  "image": "Banner-module-scss-module___R6Yya__image",
  "link": "Banner-module-scss-module___R6Yya__link",
});
